import moment from 'moment';
import { getPeriodDateFromUntil } from '@/shared/components/PeriodButtonGroup';
import { defaultFilters } from './IntraCompanyFilters';
const initPeriod = (filters) => {
    if (!filters.period)
        return filters;
    return Object.assign(Object.assign({}, filters), getPeriodDateFromUntil(filters.period));
};
export const initialFilters = (sessionFilters, stateFilters) => {
    try {
        if (stateFilters) {
            const combinedFilters = Object.assign(Object.assign({}, defaultFilters), stateFilters);
            if (JSON.stringify(combinedFilters) !== JSON.stringify(defaultFilters))
                return initPeriod(combinedFilters);
        }
        if (!sessionFilters)
            return Object.assign({}, defaultFilters);
        if (typeof sessionFilters === 'string') {
            sessionFilters = JSON.parse(sessionFilters);
        }
        if (sessionFilters) {
            if (typeof sessionFilters.dateFrom === 'string')
                sessionFilters.dateFrom = moment.utc(sessionFilters.dateFrom);
            if (typeof sessionFilters.dateUntil === 'string')
                sessionFilters.dateUntil = moment.utc(sessionFilters.dateUntil);
            return initPeriod(Object.assign(Object.assign({}, defaultFilters), sessionFilters));
        }
    }
    catch (e) {
        console.error(e);
        return Object.assign({}, defaultFilters);
    }
};
